import React, { PureComponent } from 'react'
import Icon from 'components/Icon';
import { Select } from 'components/InputField';
import { ImageOption } from 'containers/ChannelsPage/Forms/styledComponents';
import { colors } from 'globalStyles';
import { isObject } from 'utils/helpers';

export default class ImageSelect extends PureComponent {

  componentDidMount() {
    const { input: { value, onChange }, isMultiSelect } = this.props;
    if (isMultiSelect && Array.isArray(value)) {
      var result = [];
      value.map(x => {
        result.push({ file: { name: x.image || x.name || (x.file ? x.file.name : null) }, selected: false });
      })
      onChange(result.filter(x => x));
    }
  }

  componentDidUpdate(prevProps) {
    const { input: { value, onChange }, isMultiSelect } = this.props;
    if (isMultiSelect) {
      var result = prevProps.input.value;
      if (isObject(value) && value[0] && !Array.isArray(value)) {
        if (!result) result = [];
        result = result.map(x => {
          x.selected = false;
          return x;
        })
        if (!result.find(x => x.file.name === value[0].name)) {
          result.unshift({ file: value[0], selected: true });
        }
        onChange(result);
      }
    }
  }

  getValues = () => {
    const { input: { value }, isMultiSelect } = this.props;
    var result = null;

    if (isObject(value) && value[0]) {
      if (isMultiSelect) {
        result = Array.isArray(value) ? value.map(x => x.file ? x.file.name : (x.image ? x.image : x)) : [value[0].name];
      } else {
        result = value[0].name;
      }
    }
    else {
      result = value;
    }

    return result;
  }

  listChanged = (listChanged) => {
    const { input } = this.props;
    var newList = [];
    listChanged.map(value => {
      newList.push(input.value.find(x => x.file === value || (x.file && x.file.name === value) || x === value));
    })
    input.onChange(newList);
  }

  listSelectChanged = (listSelected) => {
    var list = [];
    this.props.input.value.map(item => {
      const selected = listSelected.find(x => item.file === x || (item.file && item.file.name === x) || x === item);
      if (!Array.isArray(item)) {
        list.push({
          file: item.file ? item.file : { name: item },
          selected: selected ? true : false
        });
      }
    });

    this.props.input.onChange(list);
  }

  render() {
    const { input, isMultiSelect } = this.props;
    const inputValue = this.getValues();
    return (
      <div>
        <Select
          {...this.props}
          input={{ ...input, value: inputValue }}
          listChanged={this.listChanged}
          listSelectChanged={this.listSelectChanged}
          inputDisabled={true}
          optionsContainerClass="flex-display"
          leftIcon={<Icon size='16' name='image' fill={(!isMultiSelect && input.value) && colors.GREEN} />}
          CustomOption={({ value, onClick, selected }) => (
            <ImageOption
              key={value}
              onClick={onClick}
              selected={selected}>
              <div style={{ backgroundImage: `url(${value})` }} />
            </ImageOption>
          )}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/components/ImageSelect.js